
interface InactivateConfirmModalProps {
  isOpen: boolean;
  isSubmitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function InactivateConfirmModal({
  isOpen,
  isSubmitting,
  onConfirm,
  onCancel,
}: InactivateConfirmModalProps) {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="inactivate-dialog-title"
    >
      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: '8px',
          padding: '28px 32px',
          maxWidth: '520px',
          width: '90%',
          boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
        }}
      >
        <h2
          id="inactivate-dialog-title"
          style={{ margin: '0 0 16px', fontSize: '1.2rem', color: '#e65100' }}
        >
          &#9888; Inactivate BRG
        </h2>
        <p style={{ margin: '0 0 24px', color: '#444', lineHeight: 1.6 }}>
          <strong>Warning!</strong> This action will make this BRG Inactive! This BRG will no longer
          be visible. All members will be removed from this BRG. No members can join this BRG.
        </p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button
            onClick={onCancel}
            disabled={isSubmitting}
            style={{
              padding: '8px 20px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              backgroundColor: '#fff',
              cursor: 'pointer',
              fontSize: '0.95rem',
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isSubmitting}
            style={{
              padding: '8px 20px',
              border: 'none',
              borderRadius: '4px',
              backgroundColor: '#e65100',
              color: '#fff',
              cursor: isSubmitting ? 'wait' : 'pointer',
              fontSize: '0.95rem',
            }}
          >
            {isSubmitting ? 'Processing...' : 'Continue'}
          </button>
        </div>
      </div>
    </div>
  );
}
